import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';

import { useModal } from '../../../hooks/useModal';

import AutoSaveTextField from '../../AutoSaveTextField';
import BarcodeReaderModal from '../../BarcodeReaderModal';

const UpdateReferenceLocationInputComponent = ({ value, disabled, handleUpdate, onFormChange }) => {
    const { t } = useTranslation();

    const [isOpened, toggleModal] = useModal(false);

    const [isError, setIsError] = useState(false);

    const handleBlur = event => {
        const newValue = event.target.value;
        const isEmpty = !newValue;

        if (isEmpty !== isError) {
            setIsError(isEmpty);
        }

        if (isEmpty) {
            onFormChange?.({ externalReferenceLocation: '' });
            return;
        }

        handleUpdate('basicInformation', {
            basicInformation: {
                externalReferenceLocation: newValue,
            },
        });
    };

    const handleResult = result => {
        if (!!result && isOpened) {
            handleUpdate('basicInformation', {
                basicInformation: {
                    externalReferenceLocation: result,
                },
            });
            toggleModal();
        }
    };

    return (
        <>
            <AutoSaveTextField
                required
                error={isError || !value}
                value={value}
                disabled={disabled}
                InputProps={{
                    endAdornment: <QrCodeRoundedIcon onClick={toggleModal} />,
                }}
                label={t('report.form.locationReference')}
                onBlur={handleBlur}
                onKeyPress={event => {
                    event.key === 'Enter' && handleBlur(event);
                }}
                fullWidth
            />
            <BarcodeReaderModal isOpen={isOpened} handleModalClose={toggleModal} handleResult={handleResult} />
        </>
    );
};

const UpdateReferenceLocationInput = memo(UpdateReferenceLocationInputComponent);

export default UpdateReferenceLocationInput;
